module.exports = __webpack_public_path__ + "static/media/generalli.273f39a6.svg";